import { useField } from 'formik'
import React from 'react'
import { AnyObject, ObjectSchema } from 'yup'

export type RadioInputOption = { value: string; label: string; icon?: React.ElementType; selectable?: boolean }
interface RadioInputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  name: string
  showError?: boolean
  options?: RadioInputOption[]
  schema?: ObjectSchema<AnyObject>
}
//JSX.IntrinsicElements["input"]
const RadioInputField: React.FC<RadioInputFieldProps> = ({ className, label, options = [], schema, ...props }) => {
  const [field, meta] = useField(props.name)

  const { error } = meta
  return (
    <fieldset className="mt-4">
      <legend className="sr-only">{label}</legend>

      <div className={className}>
        <label htmlFor={field.name} className={`block text-sm font-medium ${error ? 'text-red-500' : 'text-gray-700'}`}>
          {label}
          {props.required && <span className="ml-1 text-red-500">*</span>}
        </label>
        <div className="mt-1 flex flex-row">
          {options
            .filter((x) => x.selectable ?? true)
            .map((o, idx) => (
              <label key={`pm-${idx}`} className="mr-6 flex flex-row items-center justify-center space-x-2">
                <input
                  type="radio"
                  {...field}
                  {...props}
                  value={o.value}
                  checked={field.value === o.value}
                  className="text-primary ring-primary ring-offset-primary"
                />
                <div className="ml-2 py-2">{o.label}</div>
              </label>
            ))}
        </div>
        {/* {showError && error && <p className="mt-2 text-sm text-red-500">{error}</p>} */}
      </div>
    </fieldset>
  )
}

export default RadioInputField
